import { v4 as _uuidv4 } from 'uuid';

export function uuidv4(): string {
    return _uuidv4();
}
